export default __webpack_public_path__ + "static/media/welcome_screens-slideout.a6dce340.jpg";